import { defaultResumeData, idSchema, resumeDataSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

export const resumeSchema = z.object({
  id: idSchema,
  title: z.string(),
  slug: z.string(),
  data: resumeDataSchema.default(defaultResumeData),
  visibility: z.enum(["private", "public"]).default("private"),
  locked: z.boolean().default(false),
  userId: z.number().int(), // userId is INTEGER in the database (references main.users.id)
  saasflowId: z.number().int().nullable().optional(),
  user: userSchema.optional(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
  disabled: z.boolean().default(false),
});

export class ResumeDto extends createZodDto(resumeSchema) { }
